import { combineReducers } from 'redux';

import dns from './dns/dnsReducer';
import firewall from './firewall/firewallReducer';

export default combineReducers({
	dns,
	firewall,
});
